export {default} from './UserInfo';
